import { Controller } from "@hotwired/stimulus"

// Submit behaviour for the ask card (see _forms.scss "Ask card"): a Continue
// button that submits, a Skip button that submits with skip=1, and the
// focus/blur styling for the inline "or add your own" chip input. Shared by
// onboarding, the Serendipity correct-me card, and the Judicial choice form.

export default class extends Controller {
    static targets = ["form", "customInput", "commitField"]

    continue(event) {
        event.preventDefault()
        this.submit("continue")
    }

    skip(event) {
        event.preventDefault()
        this.submit("skip")
    }

    submit(action) {
        if (this.hasCommitFieldTarget) this.commitFieldTarget.value = action
        let form = this.hasFormTarget ? this.formTarget : this.element
        let skipField = form.querySelector('input[name="skip"]')
        if (action === "skip") {
            if (!skipField) {
                skipField = document.createElement("input")
                skipField.type = "hidden"
                skipField.name = "skip"
                skipField.value = "1"
                form.appendChild(skipField)
            }
        } else if (skipField) {
            skipField.remove()
        }
        form.requestSubmit()
    }

    focusCustom(event) { event.currentTarget.classList.add("is-focused") }
    blurCustom(event) {
        let input = event.currentTarget
        if (!input.value.trim()) input.classList.remove("is-focused")
    }
    inputCustom(event) {
        let input = event.currentTarget
        input.classList.toggle("is-focused", input.value.trim().length > 0)
    }
}
